import 'core-js/stable';
import 'regenerator-runtime/runtime';

import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VModal from 'vue-js-modal'
import PhoneMaskInput from "vue-phone-mask-input";
import Notifications from 'vue-notification'
import config from './device_config'
import WrapperPage from './components/WrapperPage';
import SocketService from './services/socketService';
import EventEmitterService from "./services/eventEmitterService";
import InitService from "./services/initService";
import CrudService from './services/crudService';
import TimeService from './services/timeService';
import AuthService from './services/authService';
import LanguageService from './services/languageService';
import StatusService from './services/statusService';
import { MODAL, MODAL_TYPE_MOBILE, ERROR_CODE, USER_ROLE } from './components/devices/OperatorWorkspace/config'
import TicketService from "./services/ticketService";
import TagsService from "./services/tagsService";
import NotificationService from "./services/notificationService";
import GroupParamsService from "./services/GroupParamsService";
import CacheService from "./services/CacheService";

import '../src/assets/custom_js/meta';
import './styles/app.scss'

Vue.use(VueRouter);
Vue.use(VueAxios, axios);
Vue.use(VModal);
Vue.use(Notifications);
Vue.config.productionTip = false;
Vue.prototype.$deviceConfig = config;
Vue.prototype.$eventEmitter = new EventEmitterService();
Vue.prototype.$socketService = new SocketService();
Vue.prototype.$initService = new InitService();
Vue.prototype.$crudService = new CrudService();
Vue.prototype.$timeService = new TimeService();
Vue.prototype.$authService = new AuthService();
Vue.prototype.$languageService = new LanguageService();
Vue.prototype.$statusService = new StatusService();
Vue.prototype.$ticketService = new TicketService();
Vue.prototype.$tagsService = new TagsService();
Vue.prototype.$notificationService = new NotificationService();
Vue.prototype.$groupParamsService = new GroupParamsService();
Vue.prototype.$cacheService = Vue.observable(new CacheService());
Vue.prototype.$MODAL_TYPE_MOBILE = MODAL_TYPE_MOBILE;
Vue.prototype.$MODAL_NAME = MODAL;
Vue.prototype.$ERROR_CODE = ERROR_CODE;
Vue.prototype.$USER_ROLE = USER_ROLE;

Vue.filter('translate', Vue.prototype.$languageService.translateFilter);

new Vue({
  render: h => h(App),
  router: new VueRouter({
    routes: [
      { path: '/', name: 'home', component: WrapperPage}
    ]
  })
}).$mount('#app');

function setBodyHeightTo100vh() {
  const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
  document.body.style.height = `${vh}px`;
}

setBodyHeightTo100vh();

window.onresize = () => {
  setBodyHeightTo100vh();
}
